import { defineAgenda, param } from '@/shared/navigation/core';
import { projectFormAgenda } from './project';
import { serieFormAgenda, serieDetailAgenda } from './serie';
import { productFormAgenda, productDetailAgenda } from './product';

export const plannerAgenda = defineAgenda({
  id: 'app.planner',
  path: 'app/planner',
  open: {},
  state: {
    activeNodeId: param.uuid().optional(),
  },
  title: 'Planner',
  icon: 'folders-tree',
  presentationHints: {
    shell: {
      layoutMode: 'list-detail',
      // Zakládací formuláře (projekt, produkt, série) i detail produktu se otevírají jako detail
      // vpravo v list-detail layoutu.
      detailAgendaAllowlist: [
        projectFormAgenda.id,
        productFormAgenda.id,
        serieFormAgenda.id,
        productDetailAgenda.id,
        serieDetailAgenda.id,
      ],
    },
  },
});
